import { LiveData, Service } from '@toeverything/infra';

import type { Server } from '../entities/server';

export class WorkspaceServerService extends Service {
  server: Server | null = null;
  readonly server$ = new LiveData<Server | null>(null);

  bindServer(server: Server) {
    this.server = server;
    this.server$.setValue(server);
  }
}
